import KatalMetricsDriverConsoleLogJson from "@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson";
import KatalMetricsDriver from "@amzn/katal-metrics/lib/driver/KatalMetricsDriver";
import metricsDriverSushi from "@amzn/katal-metrics-driver-sushi";
import { getRealm } from "@amzn/squad-front-end-shared-react-components";
import errorHandler from "./errorHandler";

// Debug driver for logging to console
const consoleDriver = new KatalMetricsDriverConsoleLogJson();

const parts = window.location.hostname.split(".");
let domain = "test";
switch (parts[0]) {
  // stages explicitely defined to make sure no strange domains.
  case "alpha":
  case "beta":
  case "gamma":
  case "prod":
    [domain] = parts;
    break;
  default:
    if (window.location.hostname.includes("a2z.com")) {
      domain = "prod";
    }
}

// Production driver using sushi to log to PMET
const sushiMetricsDriver = new metricsDriverSushi.Builder()
  .withDomainRealm(domain, getRealm() || "USAmazon")
  .withErrorHandler(errorHandler)
  .build();

/**
 * Factory that returns the proper driver for KatalMetrics logging.
 *
 * @export
 * @param {boolean} isProduction
 * @returns
 */
export default function(isProduction: boolean): KatalMetricsDriver {
  return isProduction ? sushiMetricsDriver : consoleDriver;
}
